// extracted by mini-css-extract-plugin
module.exports = {"displayField":"displayField_displayField__1T7Uy","label":"displayField_label__3_usT","value":"displayField_value__3Os72"};